module.exports = __webpack_public_path__ + "static/media/MessagesIcon.bfb58bfb.svg";